import React, { useState } from "react";
import { Modal, message } from "antd";
import { Loader2 } from "lucide-react";
import { mfaApi } from "../../../api/mfa";
import { MFA_STATUS_CHANGED_EVENT } from "../../../components/Layout/MfaNudgeBanner";

interface MfaDisableModalProps {
  open: boolean;
  userId: string;
  onClose: () => void;
  onDisabled: () => void;
}

const MfaDisableModal: React.FC<MfaDisableModalProps> = ({
  open,
  userId,
  onClose,
  onDisabled,
}) => {
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleClose = () => {
    setPassword("");
    setCode("");
    onClose();
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await mfaApi.disable(userId, password, code);
      message.success("Two-factor authentication disabled");
      window.dispatchEvent(new Event(MFA_STATUS_CHANGED_EVENT));
      onDisabled();
      handleClose();
    } catch (error) {
      message.error("Incorrect password or code");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={null}
      width={420}
      centered
      maskClosable={false}
    >
      <div className="py-2 space-y-4">
        <h2 className="text-lg font-semibold text-gray-900">
          Disable two-factor authentication
        </h2>
        <p className="text-sm text-gray-600">
          Confirm your password and a current code (from your authenticator
          app or a backup code).
        </p>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Password
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Code
          </label>
          <input
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="6-digit code or backup code"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
          />
        </div>
        <button
          type="button"
          onClick={handleSubmit}
          disabled={!password || !code || submitting}
          className="w-full flex items-center justify-center gap-2 px-4 py-2 rounded-lg font-medium text-white bg-red-600 hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {submitting ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" />
              Disabling...
            </>
          ) : (
            "Disable"
          )}
        </button>
      </div>
    </Modal>
  );
};

export default MfaDisableModal;
